import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { pushPageView } from '@dmp/utils/gtm';

/**
 * App-wide root layout that wraps every route group.
 *
 * Its sole job is to fire a GTM page_view on every client-side navigation so
 * that all pages — across the main app, auth, policy and 404 route groups —
 * are tracked in Google Analytics, not just the initial hard load.
 */
export const RootLayout = () => {
  const location = useLocation();

  useEffect(() => {
    pushPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return <Outlet />;
};
